<template>
  <div>
    <component :is="headingTag">
      {{ sectionTitle }}
      <small v-if="sectionSlug">
        <router-link
          :to="{
            name: 'PostsSection',
            params: { sectionSlug: sectionSlug }
          }"
        >
          &#x2192;
        </router-link>
      </small>
    </component>

    <NewsPost
      v-for="post in postList"
      :key="post.id"
      :newsPost="post"
      class="mb-2"
    />
  </div>
</template>

<script>
import NewsPost from "@/components/NewsPost.vue";

export default {
  name: "NewsPostList",
  components: { NewsPost },
  props: {
    sectionTitle: {
      type: String,
      required: true
    },
    sectionSlug: {
      type: String,
      default: null
    },
    perPage: {
      type: Number,
      default: 0
    },
    postList: {
      type: Array,
      required: true
    },
    totalPosts: {
      type: Number,
      required: true
    },
    pagination: {
      type: Boolean,
      default: false
    },
    headingTag: {
      type: String,
      default: "h1"
    }
  }
};
</script>
